import { request } from '@/shared/api/http'
import type { Currency, PaymentPageResponse } from '@/shared/api/types'

// Публичные ручки: страницу оплаты открывает покупатель, токена нет.
const BASE = '/payments'

export const payments = {
  page(invoiceId: string, signal?: AbortSignal) {
    return request<PaymentPageResponse>(
      `${BASE}/${encodeURIComponent(invoiceId)}`,
      { anonymous: true, signal: signal ?? null },
    )
  },

  /**
   * Выбор валюты. Необратим: бекенд выдаёт адрес и запрещает менять
   * валюту после этого — платёж на выданный ранее адрес потерялся бы.
   */
  selectCurrency(invoiceId: string, currency: Currency, signal?: AbortSignal) {
    return request<PaymentPageResponse>(
      `${BASE}/${encodeURIComponent(invoiceId)}/currency`,
      { method: 'POST', body: { currency }, anonymous: true, signal: signal ?? null },
    )
  },
}
